export default __webpack_public_path__ + "f407e26cbc511709cf39e71dcf5f59ac.png";